import React, { useState, useEffect } from "react";

const API_BASE = window.location.origin;
const HOME_BASE = window.location.origin;

function ChatHistory({ loggedInUser }) {
  const [chatLogs, setChatLogs] = useState([]);

  useEffect(() => {
    const fetchChatLogs = async () => {
      try {
        const response = await fetch(
         `${API_BASE}/api/fetch_chat_logs/${loggedInUser}`
        );
        const data = await response.json();
        setChatLogs(data.chat_logs);
      } catch (error) {
        console.error("Error fetching chat logs:", error);
      }
    };

    fetchChatLogs();
  }, [loggedInUser]);

  return (
    <div className="chat-history">
      <h1>{loggedInUser}</h1>
      {chatLogs.map((log, index) => (
        <p key={index}>
          <strong>{log.sender}:</strong> {log.content}
        </p>
      ))}
        <button className="homepage-button" onClick={() => (window.location.href = `${HOME_BASE}/`)}>
        Go to Homepage</button>
    </div>
  );
}

export default ChatHistory;
